export default __webpack_public_path__ + "static/media/BG.dfc97722.svg";